import { Controller } from "@hotwired/stimulus"

// Fires one POST to record_read when the user has stayed on the page at least 3 seconds.
// Total views are counted (with 30s cooldown on the server); unique views once per user/session.
const DWELL_SECONDS = 3

export default class extends Controller {
  static values = { url: String }
  static targets = ["sentinel"]

  connect() {
    if (!this.urlValue) return
    this.sent = false
    this.dwellTimer = window.setTimeout(() => {
      this.dwellTimer = null
      if (!this.sent) {
        this.sent = true
        this.recordRead()
      }
    }, DWELL_SECONDS * 1000)
  }

  disconnect() {
    if (this.dwellTimer) {
      window.clearTimeout(this.dwellTimer)
      this.dwellTimer = null
    }
  }

  recordRead() {
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": token || "",
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).catch(() => {})
  }
}
